import React from 'react';
import { BadgeCheck, Clock, Shield, Package, Users, Award } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { features } from '../data/mock';

const iconMap = {
  BadgeCheck: BadgeCheck,
  Clock: Clock,
  Shield: Shield,
  Package: Package
};

export const About = () => {
  return (
    <section id="nosotros" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.pexels.com/photos/5463575/pexels-photo-5463575.jpeg"
                alt="Técnico trabajando"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/50 to-transparent"></div>
            </div>
            
            {/* Floating stats card */}
            <div className="absolute -bottom-8 -right-8 bg-white p-6 rounded-xl shadow-2xl border-t-4 border-blue-600">
              <div className="flex items-center gap-4">
                <div className="bg-blue-100 p-3 rounded-lg">
                  <Award className="w-8 h-8 text-blue-700" />
                </div>
                <div>
                  <div className="text-3xl font-bold text-blue-900">15+</div>
                  <div className="text-sm text-gray-600">Años de Experiencia</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-6">
              ¿Por Qué Elegirnos?
            </h2>
            <div className="w-24 h-1 bg-blue-600 mb-6"></div>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Somos una empresa líder en reparación de electrodomésticos con más de 15 años 
              de experiencia. Nuestro equipo de técnicos certificados está comprometido con 
              brindar soluciones rápidas, eficientes y duraderas.
            </p>

            <p className="text-lg text-gray-600 mb-10 leading-relaxed">
              Utilizamos repuestos originales y ofrecemos garantía en todos nuestros servicios. 
              Tu satisfacción y tranquilidad son nuestra prioridad.
            </p>

            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature, index) => {
                const IconComponent = iconMap[feature.icon] || BadgeCheck;
                return (
                  <Card 
                    key={feature.id}
                    className="border-2 border-blue-100 hover:border-blue-300 transition-all duration-300 hover:shadow-lg bg-gradient-to-br from-white to-blue-50/30"
                  >
                    <CardContent className="p-6">
                      <div className="flex items-start gap-4">
                        <div className="bg-blue-600 p-3 rounded-lg flex-shrink-0">
                          <IconComponent className="w-6 h-6 text-white" />
                        </div>
                        <div>
                          <h3 className="font-bold text-blue-900 mb-2">
                            {feature.title}
                          </h3>
                          <p className="text-sm text-gray-600">
                            {feature.description}
                          </p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-10 pt-10 border-t border-gray-200">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-700 mb-1">5000+</div>
                <div className="text-sm text-gray-600">Reparaciones</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-700 mb-1">98%</div>
                <div className="text-sm text-gray-600">Satisfacción</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-700 mb-1">24/7</div>
                <div className="text-sm text-gray-600">Disponibilidad</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
